export enum JobStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface JobResult {
  rawData: any;
  entityId?: string; // ID of the created/updated entity (e.g., map, node)
  fileUpdated?: boolean; // Indicates if the map file was regenerated for this request
  progressMessage?: string; // For intermediate progress updates
}

export interface Job {
  id: string;
  status: JobStatus;
  result?: JobResult;
  error?: string;
  createdAt: string;
  updatedAt: string;
  partialContent?: string;
  /** A smap proposal still streaming in: the nodes, links and models complete so far. */
  partialCandidate?: {map?: Record<string, unknown>; nodes: any[]; links: any[]; models: any[]};
}
